import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportSupplyDemandSkills = async (urlDataAPI: any) => {
    const { exportType, hubIds, isced4Codes, programId, locations, fromTimeline, toTimeline, isEntryLevel } = urlDataAPI;
    const { path, method } = endpoints.educationCareerPath.exportSupplyDemandSkills;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, hubIds, isced4Codes, programId, locations, fromQuarter: fromTimeline, toQuarter: toTimeline, isEntryLevel },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
